import { Component, OnInit, Optional, Inject } from '@angular/core';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import * as _ from 'lodash';
import { interval } from 'rxjs';
import { map, take } from 'rxjs/operators'
import { ConfigService } from 'src/app/core/services/config.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'confirm-user-request-access',
  templateUrl: './confirm-user-request-access.component.html',
  styleUrls: ['./confirm-user-request-access.component.scss']
})
export class ConfirmUserRequestAccessComponent implements OnInit {

  public timer: any;
  private token: any;
  public baseUrl: any;
  public time = 10;

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    @Optional() public dialogRef: MatDialogRef<ConfirmUserRequestAccessComponent>,
    public dialog: MatDialog,
    public carrierService: CarrierService,
    private configService: ConfigService,
    private flashMessageService: FlashMessageService,
  ) { }

  ngOnInit() {
    this.token = this.data.token
    this.time = !!this.data.email ? 10 : 1;
    this.getRedirectUrl();
    this.startTimer();
  }

  startTimer() {
    this.carrierService.validateToken('confirm', this.token)
      .then(() => {
        this.timer = interval(1000).pipe(
          take(this.time),
          map(x => this.time - x)
        );
        this.timer.subscribe(value => {
          if (value === 1) {
            window.location.href = `${this.baseUrl}`;
          }
        })
      })
      .catch(error => {
        this.flashMessageService.updateMessage(`Error on User registration confirmation!!`, 5000, "danger");
      });
  }
  async getRedirectUrl() {
    const config = await this.configService.getConfig()
    this.baseUrl = `https://hubconnect{{TARGET}}.hubgroup.com/login`.replace('{{TARGET}}', config.runtime.envName);
  }
}
